<script>
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import OrgList from './components/org-list.vue';
import PositionList from './components/position_ist.vue';

formCreate.component('OrgList', OrgList);
formCreate.component('PositionList', PositionList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20251204000000002',
      buttonText: {
        submit: '暂存',
        submitAudit: '提交',
      },
      buttons: {
        submitAudit: this.formConfig.code !== 'view',
      },
      childPositionOrgCode: '',
      childPositionCode: '',
      excludePositionCode: '',
      childPositionLevelCode: '',
    };
  },
  created() {},

  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'adjustType') {
        v.on = {
          ...v.on,
          change: (e) => {
            if (e === '0') {
              this.hiddenFields(true, [
                'exchangeUserName',
                'exchangePositionName2',
                'exchangeOrgName2',
                'exchangeParentUserName2',
                'exchangeParentPositionName2',
                'exchangeParentOrgName2',
                'officeType2',
                'exchangeOfficeType',
                'exchangePositionName1',
              ]);
              this.hiddenFields(false, [
                'positionType',
                'title2',
                'exchangeOrgName1',
                'exchangePositionLevelName',
                'officeType1',
                'exchangeParentPositionName1',
                'exchangeParentUserName1',
                'exchangeParentOrgName1',
              ]);
            } else if (e === '1') {
              this.hiddenFields(true, [
                'positionType',
                'exchangeOrgName1',
                'exchangePositionLevelName',
                'officeType1',
                'exchangeParentPositionName1',
                'exchangeParentUserName1',
                'exchangeParentOrgName1',
                'exchangePositionName1',
              ]);
              this.hiddenFields(false, [
                'title2',
                'exchangeUserName',
                'exchangePositionName2',
                'exchangeOrgName2',
                'exchangeParentUserName2',
                'exchangeParentPositionName2',
                'exchangeParentOrgName2',
                'officeType2',
                'exchangeOfficeType',
              ]);
            } else {
              this.hiddenFields(true, [
                'positionType',
                'title2',
                'exchangeOrgName1',
                'exchangePositionLevelName',
                'exchangePositionName1',
                'officeType1',
                'exchangeParentPositionName1',
                'exchangeParentUserName1',
                'exchangeParentOrgName1',
                'exchangeUserName',
                'exchangePositionName2',
                'exchangeOrgName2',
                'exchangeParentUserName2',
                'exchangeParentPositionName2',
                'exchangeParentOrgName2',
                'officeType2',
                'exchangeOfficeType',
              ]);
            }
            this.setValue({
              positionType: '',
              exchangeOrgCode1: '',
              exchangeOrgName1: '',
              exchangePositionLevelCode: '',
              exchangePositionLevelName: '',
              exchangePositionCode1: '',
              exchangePositionName1: '',
              officeType1: '',
              exchangeParentPositionCode1: '',
              exchangeParentPositionName1: '',
              exchangeParentUserCode1: '',
              exchangeParentUserName1: '',
              exchangeParentOrgCode1: '',
              exchangeParentOrgName1: '',
              exchangePositionCode2: '',
              exchangePositionName2: '',
              exchangeUserCode: '',
              exchangeUserName: '',
              exchangeOrgCode2: '',
              exchangeOrgName2: '',
              exchangeParentPositionCode2: '',
              exchangeParentPositionName2: '',
              exchangeParentUserCode2: '',
              exchangeParentUserName2: '',
              exchangeParentOrgCode2: '',
              exchangeParentOrgName2: '',
              officeType2: '',
              exchangeOfficeType: '',
            });
            this.childPositionOrgCode = '';
            this.childPositionCode = '';
            this.excludePositionCode = '';
          },
        };
      }
      if (v.field === 'positionType') {
        v.on = {
          ...v.on,
          change: (e) => {
            if (e === '0') {
              this.hiddenFields(true, [
                'exchangePositionName1',
              ]);
            } else if (e === '1') {
              this.hiddenFields(false, [
                'exchangePositionName1',
              ]);
            } else {
              this.hiddenFields(true, [
                'exchangePositionName1',
              ]);
            }
            this.setValue({
              exchangePositionCode1: '',
              exchangePositionName1: '',
            });
          },
        };
      }
      if (v.field === 'exchangeOrgName1') { // 选择组织
        v.props = {
          ...v.props,
          params: {
            functionCode: 'org_list',
            paramData: {
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length > 0) {
              this.setValue({
                exchangeOrgCode1: e[0].orgCode,
                exchangeOrgName1: e[0].orgName,
                exchangePositionCode1: '',
                exchangePositionName1: '',
                exchangeParentPositionCode1: '',
                exchangeParentPositionName1: '',
                exchangeParentUserCode1: '',
                exchangeParentUserName1: '',
                exchangeParentOrgCode1: '',
                exchangeParentOrgName1: '',
              });
              this.childPositionOrgCode = e[0].orgCode;
              this.disabled(false, ['exchangePositionName1', 'exchangeParentPositionName1']);
            } else {
              this.setValue({
                exchangeOrgCode1: '',
                exchangeOrgName1: '',
                exchangePositionCode1: '',
                exchangePositionName1: '',
                exchangeParentPositionCode1: '',
                exchangeParentPositionName1: '',
                exchangeParentUserCode1: '',
                exchangeParentUserName1: '',
                exchangeParentOrgCode1: '',
                exchangeParentOrgName1: '',
              });
              this.childPositionOrgCode = '';
              this.disabled(true, ['exchangePositionName1', 'exchangeParentPositionName1']);
            }
          },
        };
      }
      if (v.field === 'exchangePositionLevelName') {
        v.restful = '/mdm/mdmPositionLevelController/selectList';
        v.restfulParams = {
          enableStatus: '009',
        };
        v.props = {
          ...item.props,
          remoteParams: 'positionLevelName',
          remote: true,
          filterable: true,
        };
        v.optionsKey = {
          value: 'positionLevelCode',
          label: 'positionLevelName',
        };
        v.on = {
          ...v.on,
          getItem: (val) => {
            if (val) {
              this.setValue({
                exchangePositionLevelCode: val.positionLevelCode,
                exchangePositionLevelName: val.positionLevelName,
                exchangePositionCode1: '',
                exchangePositionName1: '',
              });
              this.childPositionLevelCode = val.positionLevelCode;
            } else {
              this.setValue({
                exchangePositionLevelCode: '',
                exchangePositionLevelName: '',
                exchangePositionCode1: '',
                exchangePositionName1: '',
              });
              this.childPositionLevelCode = '';
            }
          },
        };
      }
      if (v.field === 'exchangePositionName1') {
        v.restful = '/mdm/mdmUserController/findUserPositionSelectList';
        v.restfulParams = {
          enableStatus: '009',
          thisOrgCode: this.childPositionOrgCode,
          positionLevelCode: this.childPositionLevelCode,
        };
        v.props = {
          ...item.props,
          remoteParams: 'unionName',
          remote: true,
          filterable: true,
        };
        v.optionsKey = {
          value: 'positionCode',
          label: 'unionName',
        };
        v.on = {
          ...v.on,
          getItem: (val) => {
            if (val) {
              this.setValue({
                exchangePositionCode1: val.positionCode,
                exchangePositionName1: val.positionName,
                exchangeParentPositionCode1: '',
                exchangeParentPositionName1: '',
                exchangeParentUserCode1: '',
                exchangeParentUserName1: '',
                exchangeParentOrgCode1: '',
                exchangeParentOrgName1: '',
              });
              this.childPositionCode = val.positionCode;
              this.excludePositionCode = val.positionCode;
            } else {
              this.setValue({
                exchangePositionCode1: '',
                exchangePositionName1: '',
                exchangeParentPositionCode1: '',
                exchangeParentPositionName1: '',
                exchangeParentUserCode1: '',
                exchangeParentUserName1: '',
                exchangeParentOrgCode1: '',
                exchangeParentOrgName1: '',
              });
              this.childPositionCode = '';
              this.excludePositionCode = '';
            }
          },
        };
      }
      if (v.field === 'exchangeParentPositionName1') {
        v.restful = '/mdm/mdmUserController/findUserPositionSelectList';
        v.restfulParams = {
          enableStatus: '009',
          childPositionOrgCode: this.childPositionOrgCode,
          childPositionCode: this.childPositionCode,
          excludePositionCode: this.excludePositionCode,
        };
        v.props = {
          ...item.props,
          remoteParams: 'unionName',
          remote: true,
          filterable: true,
        };
        v.optionsKey = {
          value: 'positionCode',
          label: 'unionName',
        };
        v.on = {
          ...v.on,
          getItem: (val) => {
            if (val) {
              this.setValue({
                exchangeParentPositionCode1: val.positionCode,
                exchangeParentPositionName1: val.positionName,
                exchangeParentUserCode1: val.userName,
                exchangeParentUserName1: val.fullName,
                exchangeParentOrgCode1: val.orgCode,
                exchangeParentOrgName1: val.orgName,
              });
            } else {
              this.setValue({
                exchangeParentPositionCode1: '',
                exchangeParentPositionName1: '',
                exchangeParentUserCode1: '',
                exchangeParentUserName1: '',
                exchangeParentOrgCode1: '',
                exchangeParentOrgName1: '',
              });
            }
          },
        };
      }
      if (v.field === 'exchangePositionName2') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'position_ist',
            paramData: {
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length > 0) {
              this.setValue({
                exchangePositionCode2: e[0].positionCode,
                exchangePositionName2: e[0].positionName,
                exchangeUserCode: e[0].userName,
                exchangeUserName: e[0].fullName,
                exchangeOrgCode2: e[0].orgCode,
                exchangeOrgName2: e[0].orgName,
                exchangeParentPositionCode2: '',
                exchangeParentPositionName2: '',
                exchangeParentUserCode2: '',
                exchangeParentUserName2: '',
                exchangeParentOrgCode2: '',
                exchangeParentOrgName2: '',
              });
              this.childPositionOrgCode = e[0].orgCode;
              this.childPositionCode = e[0].positionCode;
              this.excludePositionCode = e[0].positionCode;
              this.disabled(false, ['exchangeParentPositionName2']);
            } else {
              this.setValue({
                exchangePositionCode2: '',
                exchangePositionName2: '',
                exchangeUserCode: '',
                exchangeUserName: '',
                exchangeOrgCode2: '',
                exchangeOrgName2: '',
                exchangeParentPositionCode2: '',
                exchangeParentPositionName2: '',
                exchangeParentUserCode2: '',
                exchangeParentUserName2: '',
                exchangeParentOrgCode2: '',
                exchangeParentOrgName2: '',
              });
              this.childPositionOrgCode = '';
              this.childPositionCode = '';
              this.excludePositionCode = '';
              this.disabled(true, ['exchangeParentPositionName2']);
            }
          },
        };
      }
      if (v.field === 'exchangeParentPositionName2') {
        v.restful = '/mdm/mdmUserController/findUserPositionSelectList';
        v.restfulParams = {
          enableStatus: '009',
          childPositionOrgCode: this.childPositionOrgCode,
          childPositionCode: this.childPositionCode,
          excludePositionCode: this.excludePositionCode,
        };
        v.props = {
          ...item.props,
          remoteParams: 'unionName',
          remote: true,
          filterable: true,
        };
        v.optionsKey = {
          value: 'positionCode',
          label: 'unionName',
        };
        v.on = {
          ...v.on,
          getItem: (val) => {
            if (val) {
              this.setValue({
                exchangeParentPositionCode2: val.positionCode,
                exchangeParentPositionName2: val.positionName,
                exchangeParentUserCode2: val.userName,
                exchangeParentUserName2: val.fullName,
                exchangeParentOrgCode2: val.orgCode,
                exchangeParentOrgName2: val.orgName,
              });
            } else {
              this.setValue({
                exchangeParentPositionCode2: '',
                exchangeParentPositionName2: '',
                exchangeParentUserCode2: '',
                exchangeParentUserName2: '',
                exchangeParentOrgCode2: '',
                exchangeParentOrgName2: '',
              });
            }
          },
        };
      }
      return v;
    },
    /**
     * 表单渲染完成后回调
     */
    async formComplete() {
      this.hiddenFields(true, [
        'positionType',
        'title2',
        'exchangeOrgName1',
        'exchangePositionLevelName',
        'exchangePositionName1',
        'officeType1',
        'exchangeParentPositionName1',
        'exchangeParentUserName1',
        'exchangeParentOrgName1',
        'exchangeUserName',
        'exchangePositionName2',
        'exchangeOrgName2',
        'exchangeParentUserName2',
        'exchangeParentPositionName2',
        'exchangeParentOrgName2',
        'officeType2',
        'exchangeOfficeType',
      ]);
      this.disabled(true, ['exchangePositionName1', 'exchangeParentPositionName1', 'exchangeParentPositionName2']);
      if (this.formConfig.code === 'add') {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.setValue({
          userCode: userInfo.userName,
          userName: userInfo.fullName,
          positionCode: userInfo.positionCode,
          positionName: userInfo.positionName,
          orgCode: userInfo.orgCode,
          orgName: userInfo.orgName,
          parentUserCode: userInfo.parentUserName,
          parentUserName: userInfo.parentFullName,
          parentPositionCode: userInfo.parentCode,
          parentPositionName: userInfo.parentName,
          parentOrgCode: userInfo.parentOrgCode,
          parentOrgName: userInfo.parentOrgName,
          positionLevelCode: userInfo.positionLevelCode,
          positionLevelName: userInfo.positionLevelName,
        });
      }
      if (this.formConfig.code === 'view' || this.formConfig.code === 'edit' || this.id) {
        await this.init();
      }
    },
    async init() {
      const { row } = this.formConfig;
      const data = await request.post('/mdm/mdmexchangeapply/query', { id: this.formConfig.row.id || this.id || '' }).then((res) => (res.success ? res.result : []));
      if (data.adjustType === '0') {
        this.hiddenFields(true, [
          'exchangeUserName',
          'exchangePositionName2',
          'exchangeOrgName2',
          'exchangeParentUserName2',
          'exchangeParentPositionName2',
          'exchangeParentOrgName2',
          'officeType2',
          'exchangeOfficeType',
          'exchangePositionName1',
        ]);
        this.hiddenFields(false, [
          'positionType',
          'title2',
          'exchangeOrgName1',
          'exchangePositionLevelName',
          'officeType1',
          'exchangeParentPositionName1',
          'exchangeParentUserName1',
          'exchangeParentOrgName1',
        ]);
        data.exchangeOrgCode1 = data.exchangeOrgCode;
        data.exchangeOrgName1 = data.exchangeOrgName;
        data.officeType1 = data.officeType;
        data.exchangeParentPositionCode1 = data.exchangeParentPositionCode;
        data.exchangeParentPositionName1 = data.exchangeParentPositionName;
        data.exchangeParentUserCode1 = data.exchangeParentUserCode;
        data.exchangeParentUserName1 = data.exchangeParentUserName;
        data.exchangeParentOrgCode1 = data.exchangeParentOrgCode;
        data.exchangeParentOrgName1 = data.exchangeParentOrgName;
        this.childPositionOrgCode = data.exchangeOrgCode;
        this.childPositionLevelCode = data.exchangePositionLevelCode;
        this.childPositionCode = data.exchangePositionCode;
        this.excludePositionCode = data.exchangePositionCode;
        if (data.exchangeOrgName) {
          this.disabled(false, ['exchangePositionName1', 'exchangeParentPositionName1']);
        }
        this.getRule('exchangePositionName1').restfulParams = {
          enableStatus: '009',
          thisOrgCode: this.childPositionOrgCode,
          positionLevelCode: this.childPositionLevelCode,
        };
        this.getRule('exchangeParentPositionName1').restfulParams = {
          enableStatus: '009',
          childPositionOrgCode: this.childPositionOrgCode,
          childPositionCode: this.childPositionCode,
          excludePositionCode: this.excludePositionCode,
        };
      } else if (data.adjustType === '1') {
        this.hiddenFields(true, [
          'positionType',
          'exchangeOrgName1',
          'exchangePositionLevelName',
          'officeType1',
          'exchangeParentPositionName1',
          'exchangeParentUserName1',
          'exchangeParentOrgName1',
          'exchangePositionName1',
        ]);
        this.hiddenFields(false, [
          'title2',
          'exchangeUserName',
          'exchangePositionName2',
          'exchangeOrgName2',
          'exchangeParentUserName2',
          'exchangeParentPositionName2',
          'exchangeParentOrgName2',
          'officeType2',
          'exchangeOfficeType',
        ]);
        data.exchangePositionCode2 = data.exchangePositionCode;
        data.exchangePositionName2 = data.exchangePositionName;
        data.exchangeOrgCode2 = data.exchangeOrgCode;
        data.exchangeOrgName2 = data.exchangeOrgName;
        data.exchangeParentPositionCode2 = data.exchangeParentPositionCode;
        data.exchangeParentPositionName2 = data.exchangeParentPositionName;
        data.exchangeParentUserCode2 = data.exchangeParentUserCode;
        data.exchangeParentUserName2 = data.exchangeParentUserName;
        data.exchangeParentOrgCode2 = data.exchangeParentOrgCode;
        data.exchangeParentOrgName2 = data.exchangeParentOrgName;
        data.officeType2 = data.officeType;
        this.childPositionOrgCode = data.exchangeOrgCode;
        this.childPositionCode = data.exchangePositionCode;
        this.excludePositionCode = data.exchangePositionCode;
        if (data.exchangePositionName) {
          this.disabled(false, ['exchangeParentPositionName2']);
        }
        this.getRule('exchangeParentPositionName2').restfulParams = {
          enableStatus: '009',
          childPositionOrgCode: this.childPositionOrgCode,
          childPositionCode: this.childPositionCode,
          excludePositionCode: this.excludePositionCode,
        };
      }
      if (data.positionType === '0') {
        this.hiddenFields(true, [
          'exchangePositionName1',
        ]);
      } else if (data.positionType === '1') {
        this.hiddenFields(false, [
          'exchangePositionName1',
        ]);
        data.exchangePositionCode1 = data.exchangePositionCode;
        data.exchangePositionName1 = data.exchangePositionName;
      }
      if (this.formConfig.code === 'view') {
        this.disabled(true, ['exchangePositionName1', 'exchangeParentPositionName1', 'exchangeParentPositionName2']);
      }
      this.setValue(data);
    },
    // 提交
    async submit(type) {
      let params = this.getFormData();
      if (!params) return false;
      if (params.adjustType === '0') {
        params.exchangeOrgCode = params.exchangeOrgCode1;
        params.exchangeOrgName = params.exchangeOrgName1;
        params.officeType = params.officeType1;
        params.exchangeParentPositionCode = params.exchangeParentPositionCode1;
        params.exchangeParentPositionName = params.exchangeParentPositionName1;
        params.exchangeParentUserCode = params.exchangeParentUserCode1;
        params.exchangeParentUserName = params.exchangeParentUserName1;
        params.exchangeParentOrgCode = params.exchangeParentOrgCode1;
        params.exchangeParentOrgName = params.exchangeParentOrgName1;
      } else if (params.adjustType === '1') {
        params.exchangePositionCode = params.exchangePositionCode2;
        params.exchangePositionName = params.exchangePositionName2;
        params.exchangeOrgCode = params.exchangeOrgCode2;
        params.exchangeOrgName = params.exchangeOrgName2;
        params.exchangeParentPositionCode = params.exchangeParentPositionCode2;
        params.exchangeParentPositionName = params.exchangeParentPositionName2;
        params.exchangeParentUserCode = params.exchangeParentUserCode2;
        params.exchangeParentUserName = params.exchangeParentUserName2;
        params.exchangeParentOrgCode = params.exchangeParentOrgCode2;
        params.exchangeParentOrgName = params.exchangeParentOrgName2;
        params.officeType = params.officeType2;
      }
      if (params.positionType === '1') {
        params.exchangePositionCode = params.exchangePositionCode1;
        params.exchangePositionName = params.exchangePositionName1;
      }
      delete params.title1;
      delete params.title2;
      delete params.exchangeOrgCode1;
      delete params.exchangeOrgName1;
      delete params.exchangePositionCode1;
      delete params.exchangePositionName1;
      delete params.officeType1;
      delete params.exchangeParentPositionCode1;
      delete params.exchangeParentPositionName1;
      delete params.exchangeParentUserCode1;
      delete params.exchangeParentUserName1;
      delete params.exchangeParentOrgCode1;
      delete params.exchangeParentOrgName1;
      delete params.exchangePositionCode2;
      delete params.exchangePositionName2;
      delete params.exchangeOrgCode2;
      delete params.exchangeOrgName2;
      delete params.exchangeParentPositionCode2;
      delete params.exchangeParentPositionName2;
      delete params.exchangeParentUserCode2;
      delete params.exchangeParentUserName2;
      delete params.exchangeParentOrgCode2;
      delete params.exchangeParentOrgName2;
      delete params.officeType2;
      let url = '/mdm/mdmexchangeapply/save';
      const { row, code } = this.formConfig;
      if (code === 'edit') {
        url = '/mdm/mdmexchangeapply/update';
        params = { ...params, id: row.id, code: row.code };
      }
      if (type === 1) {
        params.approveType = '0';
      } else {
        params.approveType = '1';
      }
      const { success } = await request.post(url, params);
      if (success) {
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('onClose');
        this.$emit('onGetList');
      }
    },
  },
};
</script>
